import angular from 'angular';
import strongPassword from './validation/strong-password';
import compareTo from './validation/compare-to';
import uniqueIngredientName from './validation/unique-ingredient-name';
import uniqueSystemIngredientName from './validation/unique-system-ingredient-name';
import onFileChanged from './on-file-changed';
import stopEvent from './stop-event';
import greaterThan from './validation/greater-than';
import lessThan from './validation/less-than';
import backgroundImage from './background-image';
import compareToNotEqual from './validation/compare-to-not-equal';

import uniqueUsername from './validation/unique-username';
import notNull from './validation/not-null';
import phoneNumber from './validation/phone-number';

export default angular.module('common.directives', [])
  .directive('uniqueUsername', uniqueUsername.directiveFactory)
  .directive('notNull', notNull.directiveFactory)
  .directive('phoneNumber', phoneNumber.directiveFactory)
  .directive('strongPassword', strongPassword.directiveFactory)
  .directive('compareTo', compareTo.directiveFactory)
  .directive('uniqueUserIngredientName', uniqueIngredientName.directiveFactory)
  .directive('uniqueSystemIngredientName', uniqueSystemIngredientName.directiveFactory)
  .directive('onFileChanged', onFileChanged.directiveFactory)
  .directive('stopEvent', stopEvent.directiveFactory)
  .directive('greaterThan', greaterThan.directiveFactory)
  .directive('lessThan', lessThan.directiveFactory)
  .directive('backgroundImage', backgroundImage.directiveFactory)
  .directive('compareToNotEqual', compareToNotEqual.directiveFactory)
  .name;



// WEBPACK FOOTER //
// ./common/directives/directives.module.js